module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTJMMyA3TDQuNCA1LjU1TDcgOC4xNVYwSDlWOC4xNUwxMS42IDUuNTVMMTMgN0w4IDEyWk0yIDE2QzEuNDUgMTYgMC45NzkxNjcgMTUuODA0MiAwLjU4NzUgMTUuNDEyNUMwLjE5NTgzMyAxNS4wMjA4IDAgMTQuNTUgMCAxNFYxMUgyVjE0SDE0VjExSDE2VjE0QzE2IDE0LjU1IDE1LjgwNDIgMTUuMDIwOCAxNS40MTI1IDE1LjQxMjVDMTUuMDIwOCAxNS44MDQyIDE0LjU1IDE2IDE0IDE2SDJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/icon--download-5.svg
// module id = 1496
// module chunks = 0